// EurofirmsUI Modal Component

const MODAL_ELEMENT = ".eui-modal";
const MODAL_OVERLAY_ELEMENT = ".eui-modal__overlay";
const MODAL_SCROLL_ELEMENT = "eui-modal__scrollable";
const MODAL_CLOSE_BTN = ".psfModal__btnClose";

let closeCallbacks = [];

export const EuiModalSize = {
  XS: "xs",
  S: "s",
  M: "m",
  L: "l",
  XL: "xl",
};

export function showModal(element, options = {}) {
  options.size = options?.size || EuiModalSize.M;
  $(MODAL_ELEMENT).removeClass(`eui-modal--${EuiModalSize.M}`);
  $(MODAL_ELEMENT).addClass(`eui-modal--${options?.size?.toLowerCase()}`);
  setTimeout(() => {
    const width = window.innerWidth;
    if (width <= 767 && options?.isFullScreen) {
      $(MODAL_ELEMENT, element).parent().addClass(
        "eui-modal__scrollable--full-screen"
      );
      $(MODAL_ELEMENT, element).addClass("eui-modal--full-screen");
    }
    $(element).addClass("eui-modal__wrapper--open");
    $(element).removeClass("eui-d-none");
    $(MODAL_OVERLAY_ELEMENT, element).addClass("eui-modal__overlay--open");
    $(MODAL_ELEMENT, element).addClass("eui-modal--open");
  }, 200);

  $("[eui-modal-close]").on("click", () => closeModal());
  $(`.${MODAL_SCROLL_ELEMENT}`).on("click", (event) => {
    const isTargetElement =
      event?.target?.classList[0] === MODAL_SCROLL_ELEMENT;
    isTargetElement && options?.overlayClose && closeModal();
  });

  $(window).on("resize", function (event) {
    const width = event.target.innerWidth;
    if (width <= 767 && options?.isFullScreen) {
      $(`.${MODAL_SCROLL_ELEMENT}`).addClass(
        "eui-modal__scrollable--full-screen"
      );
      $(MODAL_ELEMENT, element).addClass("eui-modal--full-screen");
    } else {
      $(`.${MODAL_SCROLL_ELEMENT}`).removeClass(
        "eui-modal__scrollable--full-screen"
      );
      $(MODAL_ELEMENT, element).removeClass("eui-modal--full-screen");
    }
  });

  $("body").css("overflow", "hidden");
  if (options?.overlayClose === undefined || options?.overlayClose === true)
    $(MODAL_OVERLAY_ELEMENT).on("click", () => closeModal());
  $(MODAL_CLOSE_BTN).on("click", () => closeModal());
}

export function closeModal() {
  const modalName = "#" + $(".eui-modal__overlay--open").parent().attr("id");
  $(".eui-modal__wrapper--open").addClass("eui-d-none");
  $(".eui-modal__wrapper--open").removeClass("eui-modal__wrapper--open");
  $(".eui-modal__overlay--open").removeClass("eui-modal__overlay--open");
  $(".eui-modal--open").removeClass("eui-modal--open");
  $("body").css("overflow", "auto");
  $("[eui-modal-close]").off("click");
  $(`.${MODAL_SCROLL_ELEMENT}`).off("click");
  $(document).off("resize");

  const modalCallbacks = closeCallbacks.find(
    (closeCallback) => closeCallback.modalName === modalName
  );
  modalCallbacks?.callbacks.forEach((callback) => callback());

  $(MODAL_OVERLAY_ELEMENT).off("click");
  $(MODAL_CLOSE_BTN).off("click");
}

export function closeSpecificModal(modalName) {
  const modal = $(modalName);
  $(".eui-modal__wrapper--open").addClass("eui-d-none");
  $(".eui-modal__wrapper--open").removeClass("eui-modal__wrapper--open");
  $(".eui-modal__overlay--open", modal).removeClass("eui-modal__overlay--open");
  $(".eui-modal--open", modal).removeClass("eui-modal--open");
  $("body").css("overflow", "auto");
  $("[eui-modal-close]").off("click");

  const modalCallbacks = closeCallbacks.find(
    (closeCallback) => closeCallback.modalName === modalName
  );
  modalCallbacks?.callbacks.forEach((callback) => callback());

  $(MODAL_OVERLAY_ELEMENT).off("click");
  $(MODAL_CLOSE_BTN).off("click");
}

export function addModalCloseCallback(modalName, newCallback) {
  let modalCallbacks = closeCallbacks.find(
    (closeCallback) => closeCallback.modalName === modalName
  );
  if (!modalCallbacks) {
    closeCallbacks.push({ modalName, callbacks: [] });
    modalCallbacks = closeCallbacks.find(
      (closeCallback) => closeCallback.modalName === modalName
    );
  }

  const alreadyHasCallback =
    modalCallbacks?.callbacks.findIndex(
      (callback) => callback === newCallback
    ) !== -1;
  if (!alreadyHasCallback) modalCallbacks?.callbacks.push(newCallback);
}

export function removeModalCloseCallback(modalName, newCallback) {
  let modalCallbacks = closeCallbacks.find(
    (closeCallback) => closeCallback.modalName === modalName
  );
  modalCallbacks?.callbacks.filter((callback) => callback !== newCallback);
}
